function DesignWrapper(props) {
    const style = {
        width: props.width,
        height: props.height
    }
    return (
        <div className="design-wrapper" style={style}>
            <img src={props.source} width={style.width} height={style.height} alt={props.alt} loading="lazy" />
        </div>
    )
}

export default DesignWrapper;